import type { FindingCategory, ScanFinding } from '@/lib/apiTypes'

export type Tab = 'overview' | 'usage' | 'misconfigurations' | 'secrets' | 'graph'

// Categories that have their own dedicated tab. Any finding whose category is
// not one of these (including null/undefined/unknown) is folded into the
// Misconfigurations tab so a finding can never silently vanish from the UI.
export const KNOWN_TAB_CATEGORIES = new Set<FindingCategory>(['secret', 'misconfiguration'])

/**
 * Does this finding belong under the given category tab? The Misconfigurations
 * tab acts as the catch-all: it captures `misconfiguration` plus any finding
 * whose category is not represented by its own tab, guaranteeing
 * sum(tab contents) === total findings.
 */
export function findingInCategory(f: ScanFinding, category: FindingCategory): boolean {
  if (category === 'misconfiguration') {
    return f.category === 'misconfiguration' || !KNOWN_TAB_CATEGORIES.has(f.category)
  }
  return f.category === category
}

